import React, {useState, useContext} from 'react';
import firebase from 'firebase';

import * as dataManager from '../adapters/data';

import { Button, Dropdown, Input, Modal } from 'semantic-ui-react';
import { GlobalContext } from '../contexts/GlobalContext';


const AddEmployeeModal = (props) => {


    const [state, setState] = useContext(GlobalContext);
    const [name, setName] = useState('');
    const [qualifications, setQualifications] = useState([]);

    const addEmployee = () => {

        if (name.trim() === '') {
            // display error, must fill out field
        }

        else {
            console.log('Employee Added');
            props.onAdd();

            dataManager.addEmployee(name, qualifications);
            props.refreshListCb();

            
        }
    }

    const updateName = (e) => {
        setName(e.target.value);
    }
    
    const updateQuals = (e, data) => {
        console.log(`updateQuals - ${JSON.stringify(data)}`);
        setQualifications(JSON.parse(data.value));
    }
    
    return (
        <div>

            <Modal dimmer='blurring' open={props.show}
                    role='dialog'
            >
            <Modal.Header>Add Employee</Modal.Header>
            <Modal.Content>
                <Input placeholder='Name' onChange={updateName} />
                <Dropdown
                    fluid
                    multiple
                    search
                    selection
                    placeholder='Qualifications'
                    options={state['qualifications'] ? state['qualifications'].map( (q) => ({key: q.id, text: q.name, value: JSON.stringify({id: q.id, name: q.name}) } )) : []}
                    onChange={updateQuals}
                />
            </Modal.Content>
            <Modal.Actions>
                <Button basic onClick={props.onClose} >
                Cancel
                </Button>
                <Button color='blue' onClick={addEmployee} >
                Add
                </Button>
            </Modal.Actions>
            </Modal>
        </div>
    );
};

export default AddEmployeeModal;